// extracted by mini-css-extract-plugin
module.exports = {"component":"video-cell_component__3cz3q"};